import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151a44a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ego" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.t("ego")) + ":  ", 1),
    _createElementVNode("b", null, _toDisplayString(_ctx.displayName), 1),
    _hoisted_2,
    (_ctx.egoAge)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/ " + _toDisplayString(_ctx.egoAge), 1))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("button", {
      class: "button is-small",
      title: _ctx.t('editego'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
    }, [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
      ])
    ], 8, _hoisted_5)
  ]))
}